module.exports = __webpack_public_path__ + "static/media/logo_etools.0cfc61c6.svg";